import { api } from "@monolith/helpers";

const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
let currentTime = new Date();

function convertHoursMinutes(time) {
  let t = time.split(":");
  return parseInt(t[0]) * 60 + parseInt(t[1]);
}

function checkOpen(ot, ct) {
  let currentMinute = currentTime.getMinutes() + currentTime.getHours() * 60;
  return currentMinute > ot && currentMinute < ct ? true : false;
}

const state = {
  orderDelivery: false,
  futurePickup: false,
  site: false,
  station: false,
  company: false,
  todayHours: {},
  currentTime: new Date(),
  vuexLoaded: false,
  deliveryTodayHours: {},
  surcharge: false,
}

const getters = {
  siteSettings: (state) => state.siteSettings,
  getHours: (state) => state.siteSettings.hours,
  getTodayHours: (state) => state.todayHours,
  getCurrentTime: (state) => state.currentTime,
  getSurcharge: (state) => state.surcharge,
  getClosed: (state) => {
    return state.siteSettings.openClose;
  },
  getDeliveryHours: (state) => state.deliveryTodayHours,
}

const actions = {

  setTodayHours({ commit }, status) {
    console.log(state.siteSettings)
    commit("setTodayHoursMutation", status);
  },

  setSiteClosed({ commit }, status) {
    commit("setClosedMutation", status);
  },

  processHolidayHours({ commit, state }) {
    let currentYear = new Date().getFullYear();
    let todaysDate = new Date().toLocaleString().split(",")[0];

    if ("hours" in state.siteSettings && "holiday" + currentYear in state.siteSettings.hours) {
      // cannot read porperty 'map' of undefined
      let hDate = state.siteSettings.hours["holiday" + currentYear].find((h) => h.date === todaysDate);
      if (hDate && state.siteSettings.auto_surcharge) {
        state.siteSettings.surcharge = true;
      } else {
        state.siteSettings.surcharge = false;
      }
    }

    if (state.siteSettings.openClose) {
      commit("setClosedMutation", true);
    }

    if (state.siteSettings.hours) {
      let day = state.siteSettings.hours.week.find((d) => d.name == days.at(currentTime.getDay())); //returns current day object
      // console.log(day);
      let normalOpen = checkOpen(convertHoursMinutes(day.openTime), convertHoursMinutes(day.closeTime)); //returns if a normal day or not boolean
      // console.log(normalOpen);
      let fullyear = new Date().getFullYear();
      state.siteSettings.hours["holiday" + fullyear] == undefined ? (fullyear = fullyear - 1) : (fullyear = fullyear);
      let holiday = state.siteSettings.hours["holiday" + fullyear].map((e) => {
        if (e.date == currentTime.toLocaleDateString()) {
          return e;
        } else {
          return false;
        }
      });
      let isHolidayToday = holiday.find((day) => day != false);
      let holidayOpen = false;
      if (isHolidayToday) {
        holidayOpen = checkOpen(convertHoursMinutes(isHolidayToday.openTime), convertHoursMinutes(isHolidayToday.closeTime));
      }
      commit("setTodayHoursMutation", day);
      if (isHolidayToday) {
        // If it's a holiday, only check holiday hours
        if (holidayOpen) {
          commit("setClosedMutation", false);
        } else {
          commit("setClosedMutation", true);
        }
      } else {
        // Not a holiday, check normal hours
        if (normalOpen) {
          commit("setClosedMutation", false);
        } else {
          commit("setClosedMutation", true);
        }
      }
    }
  },
}

const mutations = {
  setTodayHoursMutation(state, status) {
    state.todayHours = status;
  },

  setDeliveryTodayHoursMutation(state, status) {
    state.deliveryTodayHours = status;
  },

  setClosedMutation(state, status) {
    state.siteSettings.openClose = status;
  },

  initialiseSiteSettingsMutation(state, settings) {
    state.siteSettings = settings;
  },

  updateSiteSettingsMutation(state, siteSettings) {
    state.siteSettings = siteSettings;
  },

  setCurrentTimeMutation(state, time) {
    state.currentTime = time;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}